import * as React from 'react';

import { Flex, Link, Text } from '@ttoss/ui';

import { Cultivars } from '../../types/Cultivars';

import Button from '../Button/Button';
import SpecieBadge from '../SpecieBadge/SpecieBadge';

const CloneLink = ({
  children,
  href,
}: {
  children: React.ReactNode;
  href: string;
}) => {
  return (
    <Link
      href={href}
      sx={{ textTransform: 'uppercase', color: 'text', textAlign: 'center' }}
      target="_blank"
      className="clone-link"
      rel="noopener noreferrer"
    >
      {children}
    </Link>
  );
};

export type PlantDetailsCardCloneDetailsProps = {
  goBack: () => void;
} & Cultivars;

export const PlantDetailsCardCloneDetails = ({
  code,
  species,
  scientificName,
  commonName,
  cultivarURL,
  protectionURL,
  goBack,
}: PlantDetailsCardCloneDetailsProps) => {
  return (
    <Flex
      sx={{
        backgroundColor: 'white',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 8,
        padding: 7,
      }}
    >
      <SpecieBadge {...{ code, species }} />
      {commonName && <Text sx={{}}>Nome comum: {commonName}</Text>}
      {scientificName && (
        <Text sx={{ fontStyle: 'italic' }}>
          Nome científico: {scientificName}
        </Text>
      )}
      <Text sx={{ fontWeight: 'bold' }}>Acesse:</Text>
      {protectionURL && (
        <CloneLink href={protectionURL}>
          Proteção de Cultivares - Mapa
        </CloneLink>
      )}
      {cultivarURL && <CloneLink href={cultivarURL}>Rnc - Mapa</CloneLink>}
      <Button outlined onClick={() => goBack()}>
        Voltar
      </Button>
    </Flex>
  );
};

export default PlantDetailsCardCloneDetails;
